function importAll(r) {
    return r.keys().map(r);
}

const equipmentImages = importAll(require.context('./media/equipment', true, /\.(png|jpe?g|webp)$/));

const equipmentText = [{name: `Large pan/skillet`}, {name: `Large pot`},]

export const equipment = equipmentText.map((item, index) => {
    return {
        name: item.name,
        note: item.note, 
        img: equipmentImages[index]
    }
})